export const requestLogTypes: TypeDefinitions = {
    type_default_action: {
        icon: 'info',
        color: 'gray'
    },
    type_user_deleted: {
        icon: 'delete',
        color: 'danger'
    },
    type_user_not_deletable: {
        icon: 'error',
        color: 'warning'
    },
}
